import { createSlice } from '@reduxjs/toolkit';

const offersSocketSlice = createSlice({
  name: 'offersSocket',
  initialState: {
    offersSock: {},
    statusOffersSock: false,
    connected: false,
    extendedAuction: {},
    statusExtendedAuction: false,
    closeAuction: false,
  },
  reducers: {
    getOfferSocket: (state, action) => {
      state.offersSock = action.payload;
      state.statusOffer = true;
    },
    extendedAuction: (state, action) => {
      state.extendedAuction = action.payload;
      state.statusExtendedAuction = true;
    },
    removeExtendedAuction: (state) => {
      state.extendedAuction = {};
      state.statusExtendedAuction = false;
    },
    getCloseAuction: (state) => {
      state.closeAuction = true;
    },
    getConeccted: (state) => {
      state.connected = true;
    },
    disconnected: (state) => {
      state.connected = false;
    },
  },
});

export const { getOfferSocket, extendedAuction, removeExtendedAuction,
  getConeccted, disconnected, getCloseAuction } = offersSocketSlice.actions;
export default offersSocketSlice.reducer;
